export const percentVariation = (current: number | null | undefined, previous: number | null | undefined): number => {
  if (current == null || previous == null) return 0;

  if (previous === 0) {
    return current === 0 ? 0 : 100;
  }

  return ((current - previous) / previous) * 100;
};
